import { useState, useEffect } from "react";
export const useLocalStorage = (key, initialValue) => {
  const v = window.localStorage.hasOwnProperty(key)
    ? JSON.parse(localStorage[key])
    : (localStorage.setItem(key, JSON.stringify(initialValue)), initialValue);

  const [val, setVal] = useState(v);

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(val));
  }, [key, val]);

  return [val, setVal];
};
